module.exports = __webpack_public_path__ + "img/heir.c618903c.svg";